export default class Passo8 {
  constructor(id, listaPlanejamento = [], listaLiquidacaoManual = []) {
    this.id = id;
    this.listaPlanejamento = listaPlanejamento;
    this.listaLiquidacaoManual = listaLiquidacaoManual;
  }
}
